import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../../../service/seo.service';
import { NavigationEnd, Router } from '@angular/router';
import { UrlcanonicaService } from '../../../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { LicitacionService } from '../../../../service/licitacion.service';

@Component({
  selector: 'app-familias',
  templateUrl: './familias.component.html',
  styleUrls: ['./familias.component.css']
})
export class FamiliasComponent implements OnInit {
	private subscription: Subscription = new Subscription();
	RouteText : any;
	tituloseo: any;
	urlcanonicaseo: any;
	imagenseo: any;
	keywordsseo: any;
	descripcionseo: any;
	familias!: any[];
	estatusUpdate: any;
	familiaUpdate: any;
	familiidUpda: any;
	formupdate: any;
	////////
	editar = false;
	success= false;
	fail = false;
	isReadonly=false;
	addd = false;
	p: number = 1;
	parfiltros:any;
	///////

	constructor( 
		private meta: Meta,
		private title: Title,
		private _seoService: SeoService,
		private router: Router,
		private _licitacionservice: LicitacionService,
		private _urlcanonicaservice: UrlcanonicaService
		) {
			if((sessionStorage.getItem('token') == null || sessionStorage.getItem('token') == 'null')||(sessionStorage.getItem('user') == null || sessionStorage.getItem('user') == 'null')){
				this.router.navigate(['/licitaciones/administrador/login']);
			}
			this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
				this.RouteText = event;
				this.getSEO(event.url)
			});
		}

    getSEO(page: string) {
		this._seoService.getSEO(page).subscribe((resp: any) => {
			this.tituloseo = resp.titulo;
			this.descripcionseo = resp.descripcion;
			this.urlcanonicaseo = resp.urlcanonica;
			this.imagenseo = resp.image;
		
			this._urlcanonicaservice.createCanonicalLink();
			this.title.setTitle(this.tituloseo)
			this.meta.updateTag({name: 'description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:card',content: 'summary'})
			this.meta.updateTag({property: 'twitter:site',content: '@fundacionbest'})
			this.meta.updateTag({property: 'twitter:title',content: 'Fundación BEST'})
			this.meta.updateTag({property: 'twitter:description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:url',content: 'https://fundacionbest.org.mx/licitaciones/login'})
			this.meta.updateTag({property: 'og:title',content: this.tituloseo})
			this.meta.updateTag({property: 'og:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:description',content: this.descripcionseo})
		});
	}

	ngOnInit(): void {
		this.getFamilias();
	}

	getFamilias() {
        this.subscription.add(
            this._licitacionservice.familiasAdmini().subscribe((resp: any) => {
				this.familias = resp;
            })
        );
    }

	addFamilia(){this.addd = true;}

	confirmacionAgregar(form: NgForm) {
		var insert = {
			Familia:form.value.familia
		}
		this.subscription.add(
            this._licitacionservice.postInsertFamilia(insert, sessionStorage.getItem('token') ).subscribe((resp: any) => {
				form.reset();
				this.addd = false;
				this.getFamilias();
            })
        );
		
	}

	change(familia: any){
		this.estatusUpdate = familia.activa;
		this.familiaUpdate = familia.familia;
		this.familiidUpda = familia.id
		this.editar = true;
	}


	cancel() {
		this.editar = false;
		this.addd = false;
	}
	UpdateFamili(form: NgForm) {
		this.formupdate = form.value;
		this.success= true;
		this.editar = false;
	}
	closeok() {
		if(this.formupdate.estatusUpdate == null || this.formupdate.estatusUpdate == 'null'){this.formupdate.estatusUpdate = false}
		var post = {
			Id: this.familiidUpda,
			familia : this.formupdate.familiaUpdate,
			Activa: this.formupdate.estatusUpdate
		}
		this.subscription.add(
            this._licitacionservice.postUpdateFamilia(post, sessionStorage.getItem('token') ).subscribe((resp: any) => {
				this.getFamilias();
				this.success= false;
				this.editar = false;
            })
        );
	}

	closefail() {
		this.success= false;
		this.editar = true;
	}
	////////////
}
